import React, { useEffect } from 'react';
import './NotificationBar.css';
import { config } from '../config/config';

const NotificationBar = ({ message, visible, onClose }) => {
    useEffect(() => {
        if (visible) {
            const timer = setTimeout(() => {
                onClose();
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [visible, onClose]);

    if (!visible) return null;

    return (
        <div className={`notificationBar_container`}>
            <div className="notificationBar_icon">
               <img src={config.logoicon} alt="app logo" />
            </div>
            <div className="notificationBar_message">
                {message}
            </div>
        </div>
    );
};

export default NotificationBar;
